var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5C0.0520833 16.75 0.963542 13.3906 2.73438 10.4219C4.50521 7.40104 6.90104 5.00521 9.92188 3.23438C12.8906 1.46354 16.25 0.552083 20 0.5C23.75 0.552083 27.1094 1.46354 30.0781 3.23438C33.099 5.00521 35.4948 7.40104 37.2656 10.4219C39.0365 13.3906 39.9479 16.75 40 20.5C39.9479 24.25 39.0365 27.6094 37.2656 30.5781C35.4948 33.599 33.099 35.9948 30.0781 37.7656C27.1094 39.5365 23.75 40.4479 20 40.5C16.25 40.4479 12.8906 39.5365 9.92188 37.7656C6.90104 35.9948 4.50521 33.599 2.73438 30.5781C0.963542 27.6094 0.0520833 24.25 0 20.5ZM20 29.25C21.1458 29.1458 21.7708 28.5208 21.875 27.375V22.375H26.875C28.0208 22.2708 28.6458 21.6458 28.75 20.5C28.6458 19.3542 28.0208 18.7292 26.875 18.625H21.875V13.625C21.7708 12.4792 21.1458 11.8542 20 11.75C18.8542 11.8542 18.2292 12.4792 18.125 13.625V18.625H13.125C11.9792 18.7292 11.3542 19.3542 11.25 20.5C11.3542 21.6458 11.9792 22.2708 13.125 22.375H18.125V27.375C18.2292 28.5208 18.8542 29.1458 20 29.25Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.a454d65c.svg";
export { ForwardRef as ReactComponent };